import { useSelector } from 'react-redux';
import { getHasCopilotAccessScope } from '../auth/selectors/authSelectors';
import { selectIsChatspotEnabled, selectIsHipaaCoveredEntity } from '../chatspotAuth/selectors/chatspotAuthSelectors';
export const useIsCopilotEnabled = () => {
  const isPortalSettingEnabled = useSelector(selectIsChatspotEnabled);
  const hasCopilotAccess = useSelector(getHasCopilotAccessScope);
  const isHipaaCoveredEntity = useSelector(selectIsHipaaCoveredEntity);
  return Boolean(isPortalSettingEnabled && hasCopilotAccess && !isHipaaCoveredEntity);
};